var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 6.99967V10.333C14.6666 12.6663 13.3333 13.6663 11.3333 13.6663H4.66665C2.66665 13.6663 1.33331 12.6663 1.33331 10.333V5.66634C1.33331 3.33301 2.66665 2.33301 4.66665 2.33301H9.33331",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 6L6.75336 7.66667C7.44002 8.21333 8.56669 8.21333 9.25336 7.66667L10.04 7.04",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.33333C13.9205 5.33333 14.6666 4.58714 14.6666 3.66667C14.6666 2.74619 13.9205 2 13 2C12.0795 2 11.3333 2.74619 11.3333 3.66667C11.3333 4.58714 12.0795 5.33333 13 5.33333Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNotification);
export default __webpack_public_path__ + "static/media/sms-notification.12ccc96f3dc3140e0ad7e09ccbd3b1c5.svg";
export { ForwardRef as ReactComponent };